// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1nJ2g","icon":"SortAdornment_icon__2iuXI","up":"SortAdornment_up__2qyG9","down":"SortAdornment_down__13cqe","active":"SortAdornment_active__35e_A"};